/* ============================================================
   CORRIDOR CARDS — Theme JavaScript
   Easter Eggs, Interactions & Animations
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Dropdown visibility safety net ── */
  // Dawn uses <details> for nav dropdowns
  const styleDropdown = (panel) => {
    if (!panel) return;
    Object.assign(panel.style, {
      background: '#ffffff',
      backgroundImage: 'none',
      border: '2px solid #111111',
      borderTop: '3px solid #F27B20',
      boxShadow: '4px 4px 0 rgba(0,0,0,0.10)',
      zIndex: '9999',
      position: 'absolute',
      display: 'block',
      width: 'max-content',
      minWidth: '200px',
      maxWidth: '420px',
      padding: '0',
      columnCount: 'unset',
      gridTemplateColumns: 'unset',
    });
    panel.querySelectorAll('a, .list-menu__item').forEach(a => {
      Object.assign(a.style, {
        color: '#111111',
        display: 'block',
        padding: '8px 18px',
        fontFamily: "'Bangers', Impact, sans-serif",
        fontSize: '16px',
        letterSpacing: '0.05em',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        background: 'transparent',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
      });
      a.addEventListener('mouseenter', () => { a.style.color = '#F27B20'; a.style.background = 'rgba(242,123,32,0.08)'; });
      a.addEventListener('mouseleave', () => { a.style.color = '#111111'; a.style.background = 'transparent'; });
    });
  };

  document.querySelectorAll('header details, .header details').forEach(d => {
    // Ensure the <details> is the positioning parent
    d.style.position = 'relative';

    // Style on open
    d.addEventListener('toggle', () => {
      if (d.open) {
        const panel = d.querySelector('.mega-menu__content, ul.list-menu, > ul, > div:not(summary)');
        styleDropdown(panel);
      }
    });
    // Also style if already open on load
    if (d.open) {
      styleDropdown(d.querySelector('.mega-menu__content, ul.list-menu, > ul, > div:not(summary)'));
    }
  });

  /* ── Auto-detect & inject holographic hero ── */
  // Finds the first big content section regardless of theme class names
  const heroSelectors = [
    '.banner', '.hero', '[class*="hero"]', '[class*="slideshow"]',
    '[class*="video"]', '.index-section:first-of-type',
  ];
  let heroSection = null;
  for (const sel of heroSelectors) {
    heroSection = document.querySelector(sel);
    if (heroSection) break;
  }
  // Fallback: first shopify section that isn't header/footer/announcement
  if (!heroSection) {
    const sections = document.querySelectorAll('.shopify-section');
    for (const s of sections) {
      const id = s.id || '';
      if (!id.includes('header') && !id.includes('footer') && !id.includes('announcement')) {
        heroSection = s.firstElementChild || s;
        break;
      }
    }
  }
  if (heroSection) {
    heroSection.classList.add('cc-hero-detected');
    // Find the media element inside and dim it
    const media = heroSection.querySelector('img, video, .media, [class*="media"]');
    if (media) media.classList.add('cc-hero-media');

    // Fix black pillarbox bars — clear dark background on the section wrapper
    let sectionEl = heroSection.closest('.shopify-section') || heroSection.parentElement;
    while (sectionEl && !sectionEl.classList.contains('shopify-section')) {
      sectionEl = sectionEl.parentElement;
    }
    if (sectionEl) {
      sectionEl.style.background = 'transparent';
      sectionEl.style.backgroundColor = 'transparent';
      // Also clear any color-scheme child divs that set dark bg
      sectionEl.querySelectorAll('[class*="color-"]').forEach(el => {
        el.style.backgroundColor = 'transparent';
        el.style.backgroundImage = 'none';
      });
    }
  }

  /* ── Holographic card mouse tracking ── */
  document.querySelectorAll('.holo-card, .product-slot').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--mouse-x', `${x}%`);
      card.style.setProperty('--mouse-y', `${y}%`);
    });
  });

  /* ── Coin drop on Add to Cart / Dispense buttons ── */
  document.querySelectorAll('.slot-dispense, .btn-dispense').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const rect = btn.getBoundingClientRect();
      const count = 5;
      for (let i = 0; i < count; i++) {
        const coin = document.createElement('div');
        coin.className = 'coin-particle';
        coin.textContent = '🪙';
        coin.style.cssText = `
          left: ${rect.left + rect.width / 2 + (Math.random() - 0.5) * 60}px;
          top: ${rect.top}px;
          animation-delay: ${i * 80}ms;
          font-size: ${12 + Math.random() * 8}px;
          background: none;
          border: none;
        `;
        document.body.appendChild(coin);
        setTimeout(() => coin.remove(), 1200);
      }
    });
  });

  /* ── SECRET CODE EASTER EGG: type "PULLPACK" ── */
  const secret = 'PULLPACK';
  let typed = '';
  const holoColors = [
    '#ff0080','#ff4500','#ff8c00','#ffed00',
    '#39ff14','#00bfff','#8a2be2','#ff1493'
  ];

  document.addEventListener('keydown', (e) => {
    typed += e.key.toUpperCase();
    if (typed.length > secret.length) typed = typed.slice(-secret.length);

    if (typed === secret) {
      typed = '';
      triggerEasterEgg();
    }
  });

  function triggerEasterEgg() {
    /* Holographic flash overlay */
    const flash = document.createElement('div');
    flash.className = 'easter-egg-flash holo-bg';
    flash.innerHTML = `
      <div class="inner">
        <div class="msg holo-text">★ PACKED WITH HITS ★</div>
        <div style="font-family:var(--font-mono);font-size:0.9rem;color:rgba(255,255,255,0.7);margin-top:0.5rem;letter-spacing:0.2em;">YOU FOUND THE SECRET</div>
      </div>`;
    document.body.appendChild(flash);
    setTimeout(() => flash.remove(), 2500);

    /* Confetti explosion */
    const count = 80;
    for (let i = 0; i < count; i++) {
      setTimeout(() => {
        const piece = document.createElement('div');
        piece.className = 'confetti-piece';
        piece.style.cssText = `
          left: ${Math.random() * 100}vw;
          top: -20px;
          background: ${holoColors[Math.floor(Math.random() * holoColors.length)]};
          animation-duration: ${1.5 + Math.random() * 2}s;
          animation-delay: ${Math.random() * 0.5}s;
          border-radius: ${Math.random() > 0.5 ? '50%' : '2px'};
          width: ${8 + Math.random() * 12}px;
          height: ${8 + Math.random() * 12}px;
        `;
        document.body.appendChild(piece);
        setTimeout(() => piece.remove(), 3500);
      }, i * 20);
    }
  }

  /* ── Quantity selector ── */
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const display = selector.querySelector('.qty-display');
    selector.querySelector('.qty-minus')?.addEventListener('click', () => {
      const val = parseInt(display.value || display.textContent);
      if (val > 1) {
        display.value ? (display.value = val - 1) : (display.textContent = val - 1);
      }
    });
    selector.querySelector('.qty-plus')?.addEventListener('click', () => {
      const val = parseInt(display.value || display.textContent);
      display.value ? (display.value = val + 1) : (display.textContent = val + 1);
    });
  });

  /* ── Mobile nav toggle ── */
  const hamburger = document.querySelector('.btn-hamburger');
  const nav = document.querySelector('.site-nav');
  hamburger?.addEventListener('click', () => {
    const isOpen = nav.style.display === 'flex';
    nav.style.display = isOpen ? 'none' : 'flex';
    nav.style.flexDirection = 'column';
    nav.style.position = 'absolute';
    nav.style.top = '72px';
    nav.style.left = '0';
    nav.style.right = '0';
    nav.style.background = 'var(--cc-black)';
    nav.style.borderBottom = 'var(--border-thick)';
    nav.style.padding = '1rem';
    nav.style.gap = '0.5rem';
  });

  /* ── Cart drawer ── */
  const cartBtn = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtn?.addEventListener('click', openCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);

  /* ── Slot number counter (auto-number product slots) ── */
  document.querySelectorAll('.product-slot').forEach((slot, i) => {
    const badge = slot.querySelector('.slot-number');
    if (badge && !badge.textContent.trim()) {
      badge.textContent = String(i + 1).padStart(2, '0');
    }
  });

  /* ── Scroll-triggered entrance animations ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-slot, .location-card').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      observer.observe(el);
    });
  }

  /* ── LED price "flicker" on load ── */
  document.querySelectorAll('.product-price-amount, .slot-price').forEach(el => {
    let flickers = 3;
    const flicker = () => {
      if (flickers <= 0) return;
      el.style.opacity = '0.3';
      setTimeout(() => {
        el.style.opacity = '1';
        flickers--;
        if (flickers > 0) setTimeout(flicker, 80 + Math.random() * 120);
      }, 60);
    };
    setTimeout(flicker, 300 + Math.random() * 600);
  });

});
